import { useCompaniesTableStore } from "@/stores/useTableStore";

import { useAuth } from "../../../../../context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "../../../../../roles/types/enums";
import { STEP_GROUP } from "../../../types";
import useTutorialMode from "../../useTutorialMode";

const useMobileActions = (
  isCompaniesPage: boolean,
  handleTutorialCompletion: (stepGroup: STEP_GROUP) => Promise<void>,
) => {
  const {
    stepGroup,
    stepIndex,
    handleTutorialStepIndexChange,
    setIsMobileDrawerOpen,
    setTutorialDetails,
  } = useTutorialMode();
  const { getAccessStatus } = useAuth();

  const canManageCompanyCards = getAccessStatus(
    USER_PERMISSIONS.ManageCompanies,
  );

  const resetTableDetails = useCompaniesTableStore(
    (state) => state.resetTableDetails,
  );

  const companyCardsStepsCount = canManageCompanyCards ? 1 : 2;

  const handlePreviousButtonMobile = () => {
    switch (stepIndex) {
      case 1:
        setIsMobileDrawerOpen(false);
        handleTutorialStepIndexChange(stepIndex - 1);
        break;

      case 2:
        isCompaniesPage && resetTableDetails();
        break;

      case 3:
        document.getElementById("close-button")?.click();

        setTutorialDetails({
          isTutorialOpen: true,
          stepIndex: stepIndex - 1,
          stepGroup: stepGroup,
          isTutorialActive: true,
        });
        break;

      case 5:
        handleTutorialStepIndexChange(stepIndex - companyCardsStepsCount);
        break;

      default:
        handleTutorialStepIndexChange(stepIndex - 1);
        break;
    }
  };

  const handleNextButtonMobile = () => {
    switch (stepIndex) {
      case 3:
        handleTutorialStepIndexChange(stepIndex + companyCardsStepsCount);
        break;

      case 5:
        handleTutorialCompletion(STEP_GROUP.TutorialNewCompanyCard);
        break;

      default:
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
    }
  };

  return {
    handlePreviousButtonMobile,
    handleNextButtonMobile,
  };
};

export default useMobileActions;
